/* 標準的な行のテンプレート */
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';

interface Props {
  label: string;
  need?: boolean;
  content: any;
  disabled?: boolean;
}
const RowTemplate: React.FC<Props> = ({ label, need, content, disabled }) => {
  /**
   * 必須マークの表示を制御する
   * @return boolean
   */
  const isVisibleRequiredMark = () => {
    // null, undefinedの場合はdisabled === falseであるものとみなす
    return !disabled && need;
  };
  return (
    <Row className="form-row">
      <Col md={3} className="field-label">
        <p className="field-label-title">{label}</p>
        {isVisibleRequiredMark() ? (
          <span className="c-required-item-label ms-md-auto">必須</span>
        ) : null}
      </Col>
      <Col md={9} className="field-label-text">
        {content}
      </Col>
    </Row>
  );
};

export default RowTemplate;
